module.exports = __webpack_public_path__ + "assets/img/hbgd3.3901e2e5.png";